<template>
  <header v-if="ready">
    <!--img alt="Vue logo" class="logo" src="@/assets/logo.svg" width="125" height="125" /-->

    <div id="app" class="container">
      <!--NavView></NavView-->
      <div class="debug">
        <p><b>Debugging Route in App.vue:</b></p>
        <p>$route.path = {{ $route.path }}</p>
        <p>$route.params = {{ $route.params }}</p>
        <p v-for="(item, key) in $route.params"> {{key}} :{{ item }} : type= {{ typeof(item) }}</p>
        <p><b>Debugging process.env.NODE_ENV in App.vue</b></p>
        <p>{{ nodeEnv }}</p>
      </div>

      <Nav :nav-items="navItems" :isTop="true" :level=1></Nav>
      <!--div>
        <button type="button" :onClick="syncAllCache">Sync Cache with backend</button>
      </div-->
      <!--Nav :nav-items="watchedProjects" :isKillable="true"></Nav>-->
      <!--ShortListNav></ShortListNav-->
      <Alert></Alert>
      <!--Prompt></Prompt-->
      <!--div class="debug">
        <h3>App debugging watchlist store:</h3>
        <p>watchlistStore : {{ watchlistStore }}</p>
        <p>watchedProjects = {{ watchedProjects }}</p>
        <p>watching = {{ watching }}</p>
       
      </div>-->
      <div class="view-container">
        <router-view></router-view>
      </div>
    </div>
  </header>
  <div v-else>
    Initializing Cache Store...
    <p>ready = {{ ready }}</p>
  </div>

</template>

<script setup lang="ts">
import { computed, onBeforeMount } from 'vue'
import { RouterView } from 'vue-router'
import { useUserStore, useCacheStore} from '@/stores'
import { storeToRefs } from 'pinia'
import { Nav, Alert } from '@/components'
const userStore = useUserStore()
const { currentGroup } = storeToRefs(userStore)
const cache = useCacheStore();
const { ready } = storeToRefs(cache);
const nodeEnv = computed(()=>{
  return process.env.NODE_ENV;
})
onBeforeMount(()=>{
  cache.initCache();
})
//Wrap routerLinks
const allNavItems = [
  //{ to: '/projects/search', name: 'Search' },
  { to: { name: 'home' }, text: 'Home' },
  { to: { name: 'create_project' }, text: 'New Project' },
  { to: { name: 'projects_list' }, text: 'Projects' },
  { to: { name: 'customers_list' }, text: 'Customers' },
  { to: { name: 'invoices_list' }, text: 'Invoices' },
  //{ to: { name: 'postechs_list' }, text: 'Postech' },
  { to: { name: 'map' }, text: 'Map' },
  { to: { name: 'rates' }, text: 'Rates' }
]

//for limited group (no invoices):
//Wrap routerLinks
const limitedNavItems = [
  //{ to: '/projects/search', name: 'Search' },
  { to: { name: 'home' }, text: 'Home' },
  { to: { name: 'create_project' }, text: 'New Project' },
  { to: { name: 'projects_list' }, text: 'Projects' },
  { to: { name: 'customers_list' }, text: 'Customers' },
  //{ to: { name: 'invoices_list' }, text: 'Invoices' },
  //{ to: { name: 'postechs_list' }, text: 'Postech' },
  { to: { name: 'map' }, text: 'Map' }
]

const navItems = computed(() => {
  if (currentGroup.value == 'standard' || currentGroup.value == 'admin') {
    return allNavItems
  } else {
    return limitedNavItems
  }
})
</script>